module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/24c96c14be1017263fb74e840f0f166a.svg";